



































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { DateHelper } from '@/modules/shared/helpers/date'
import collect from 'collect.js'
import dayjs from 'dayjs'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import {
  ContentCampaignGetAttributesUseCase
} from '@/modules/content-campaign/use-cases/admin/content-campaign-get-attributes.use-case'
import {
  ContentCampaignUpdateAttributesUseCase
} from '@/modules/content-campaign/use-cases/admin/content-campaign-update-attributes.use-case'
import { Obj } from '@/modules/shared/helpers'
import {
  ContentCampaignUpdatableAttributesResourceModel
} from '@/modules/content-campaign/models/content-campaign-resource.model'

@Component({
  components: {
    AdminUserSearch,
    Toggle,
    BaseInput,
    BaseSelect,
    Modal,
    BaseButton
  }
})
export default class AdminContentCampaignUpdateAttributes extends Vue {
  constructor(
    private readonly getAttributesUseCase: ContentCampaignGetAttributesUseCase,
    private readonly updateAttributesUseCase: ContentCampaignUpdateAttributesUseCase,
    private readonly dateHelper: DateHelper,
    private readonly obj: Obj
  ) {
    super()
  }

  @Prop({ required: true }) contentCampaignId: number
  @Prop({ default: 'تنظیمات کمپین' }) label: string
  contentCampaignAttributes: ContentCampaignUpdatableAttributesResourceModel = null
  dialogModel: boolean = false

  //computed
  get completedAt() {
    return (this.contentCampaignAttributes.completed_at) ?
      this.getJalaliDate(this.contentCampaignAttributes.completed_at) : ''
  }

  set completedAt(value) {
    this.contentCampaignAttributes.completed_at = this.jalaliToGregory(value)
  }

  get statusOptions() {
    return collect(this.getAttributesUseCase.statuses).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }


  //methods
  jalaliToGregory(value) {
    return this.dateHelper.fromJalali(value).toTimestamp()
  }

  getJalaliDate(value) {
    return dayjs(value).format('YYYY/MM/DD')
  }

  getContentCampaignAttributes() {
    this.getAttributesUseCase.execute(this.contentCampaignId).then((resp) => {
      if (resp.isSuccess()) {
        this.contentCampaignAttributes = this.getAttributesUseCase.data
        this.dialogModel = true
      }
    })
  }

  updateContentCampaignAttributes() {
    this.obj.pop(this.contentCampaignAttributes, 'running_at')
    this.updateAttributesUseCase.execute(this.contentCampaignId, this.contentCampaignAttributes)
      .then(() => {
        if (this.updateAttributesUseCase.isSuccess) {
          this.dialogModel = false
        }
      })
  }

}
